<div class="overLayDiv active"></div>
<div id="rightSideBar" [hidden]="fmSpecialObject && fmSpecialObject.type == 1">
  <div class="rightSidePanel w-80pc active">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{ panelHeader }}</h2>
          <app-video-icon [VideoUrl]="videoLink | safeUrl"></app-video-icon>
      </div>            
      <div class="panel-left-btn">
          <button type="button" class="btn eod-btn-outline-warning mr-2" (click)="CreateNewFutureRate()"
            [disabled]="!CanCreateFutureRate">
            {{ "add_future_rate" | translate }}
          </button>
          <button type="button" class="btn eod-btn-primary mr-2" (click)="CreateNewTaxRate()">
            {{'create_new_tax_code' | translate }}
          </button>
          <button type="button" class="btn eod-btn-outline-warning" (click)="fnBacktoWizard()"
          *ngIf="!fmSpecialObject || fmSpecialObject.type != 2">
            {{ 'back_to_wizard' | translate }}
          </button>
          <button type="button" class="btn eod-btn-outline-warning" (click)="fnBacktoWizard()"
          *ngIf="fmSpecialObject && fmSpecialObject.type == 2">
            {{ 'label_close' | translate }}
          </button>
      </div>
    </header>     
    <div class="block heightCalc-5">
        <div class="heightCalc-14">
            <!----------------------Start Grid--------------------------->
            <app-grid [columns]="gridColumnDefs" [data]="gridData" [gridConfigItems]="gridConfigItems"
                (onCellClick)="fnOnGridCellClick($event)" (filterChanged)="fnGridFilterChanged($event)">
            </app-grid>
            <!----------------------End Grid--------------------------->       
        </div>
    </div>                
  </div>
</div>

<div *ngIf="ShowEditPanel"
     class="overLayDiv active"></div>

<div [hidden]="!ShowEditPanel"
     id="rightSideBar">
  <div class="rightSidePanel active">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{ CreateNewTaxHeader }}</h2>
      </div>            
      <div class="panel-left-btn">
         <button type="button" class="btn eod-btn-primary mr-2" *ngIf="!TaxRateMasterId && !IsFutureRate"
         [ngClass]="{ 'disabled': !hasFormChanges }" (click)="fnCheckForTaxRateChanges(TaxActiveStatus,1)">
             {{ 'self_setup_msg_3' | translate: param }}
          </button>
          <button type="button" class="btn eod-btn-outline-warning mr-2" [hidden]="!ShowLogPanel" (click)="fnShowConfigureshowLoggingAlertPanel()">
            {{ 'label_log' | translate: param }}
          </button>
          <button type="button" class="btn eod-btn-primary mr-2" [ngClass]="{ 'disabled': !hasFormChanges }" (click)="fnCheckForTaxRateChanges(TaxActiveStatus,0)">
            {{ 'label_save' | translate: param }}
          </button>
          <button type="button" class="btn eod-btn-outline-warning" (click)="CloseEditPanel(0)">
            {{ 'label_close' | translate: param }}
          </button>
      </div>
    </header>
    
    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 margin-top-10 no-padding-right-left">

      <div class="custom-control custom-switch text-left position-relative top--14px margin-left-15">
        <input type="checkbox"
               class="custom-control-input"
               id="customSwitches"
               [(ngModel)]="TaxActiveStatus"
               [checked]="TaxActiveStatus"
               (change)="changeActiveInactive()">
        <label class="custom-control-label bigToggle cursor-pointer f-20 fw-600 lH-25 padding-top-3 padding-left-15"
               *ngIf="TaxActiveStatus"
               for="customSwitches">{{
          'label_activate' | translate:param }}</label>
        <label class="custom-control-label bigToggle cursor-pointer f-20 fw-600 lH-25 padding-top-3 padding-left-15"
               *ngIf="!TaxActiveStatus"
               for="customSwitches">{{
          'label_deactivate' | translate:param }}</label>
      </div>

      <div class="block">
        <div class="row">
          <div *ngIf="!IsFutureRate"
               class="col-md-6 col-sm-6 padding-left-0">
            <div class="input-group">
              <input type="text"
                     class="form-control"
                     required=""
                     [(ngModel)]="TaxCode"
                     #taxCode
                     [ngClass]="{ 'has-value': taxCode.value }"
                     (change)="taxCodeChange($event.target.value)"
                     AlphaNumeric />
              <label for="taxCode"> {{'tax_code' | translate:param}}<span>*</span> </label>
              <div *ngIf="
                  ((taxCode.value == '' || TaxCode.trim() == '') &&
                    Submitted) ||
                  isTaxCodeAlreadyExists
                "
                   class="alert-danger">
                <div *ngIf="
                    (taxCode.value == '' || TaxCode.trim() == '') && Submitted
                  ">
                  <b>{{'required_validation' | translate:param}}</b>
                </div>

                <div *ngIf="isTaxCodeAlreadyExists">
                  <b>{{'tax_code_already_exists' | translate:param}}</b>
                </div>
              </div>
            </div>
          </div>

          <div [hidden]="!IsFutureRate"
               class="col-md-6 col-sm-6 padding-left-0">
            <div class="input-group requiredAsterisk" >
              <ng-select class="solo-dropdown claimantDropdown exportDropdown auditTrailDropdown" 
              [items]="TaxRateMasterListForFutureRate"
              bindLabel="taxCodeRate"
              bindValue="taxCode"
              [selectOnTab]="true"
              [(ngModel)]="TaxCode"
              (change)="setTaxMasterForFutureRate($event)"
              [clearable]="false"
              [placeholder]="'tax_rate' | translate" >
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div>
                  {{ item.taxCode }}
                </div>
              </ng-template>  
            </ng-select>
          </div>
          
          </div>
          <div class="col-md-6 col-sm-6 padding-right-0">
            <div class="input-group">
              <input type="text"
                     class="form-control"
                     required=""
                     [(ngModel)]="TaxRate"
                     #taxRate
                     [ngClass]="{ 'has-value': taxRate.value }"
                     value="{{ TaxRateText }}"
                     (keypress)="omit_special_char($event)"
                     maxlength="6"
                     (input)="onTaxRateChange()" />
              <label for="taxRate">{{'tax_rate_percent_2' | translate:param}}<span>*</span></label>
              <div *ngIf="
                  (taxRate.value == '' ||
                    showTaxRateValidation ||
                    showDuplicateTaxRateValidation) &&
                  Submitted
                "
                   class="alert-danger">
                <div *ngIf="taxRate.value == '' && Submitted">
                  <b>{{'required_validation' | translate:param}}</b>
                </div>

                <div *ngIf="showTaxRateValidation && Submitted">
                  <b>{{'tax_rate_not_equal_to_component_tax' | translate:param}}</b>
                </div>

                <div *ngIf="showDuplicateTaxRateValidation && Submitted">
                  <b>{{'tax_rate_with_same_combination_exists' | translate:param}}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row margin-top-10">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 padding-left-0 margin-top-20">
            <div class="input-group">
              <input type="text"
                     class="form-control"
                     required=""
                     [(ngModel)]="TaxAccountingCode"
                     #taxAccountingCode
                     [ngClass]="{ 'has-value': taxAccountingCode.value }"
                     (input)="onTaxAccountingCodeChange()" />
              <label for="accountingCode">{{'tax_accounting_code' | translate:param}}</label>
            </div>
          </div>
          <div class="col-md-6 col-sm-6 margin-top-20 padding-right-0">
            <div class="input-group">             
              <input class="form-control has-value"
                     #fFrmDate
                     [ngModel]="EffectiveFrom"
                     (input)="onEffectiveFromDateChange($event.target.value)" />
              <label for="effectiveFrom"> {{'uk_mileage_effict_from' | translate:param}}<span>*</span> </label>
              <app-calendar-icon></app-calendar-icon>
              <div *ngIf="(EffectiveFrom == null || EffectiveFrom == 'Invalid Date') && Submitted"
                   class="alert-danger">
                <div *ngIf="(EffectiveFrom == null || EffectiveFrom == 'Invalid Date') && Submitted">
                  <b>{{'required_validation' | translate:param}}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="block"
           *ngIf="ShowExpiredRate || !IsSingleRate || ShowFutureRate">
        <div class="row"
             id="taxRateSetup-expiredSlab">
          <div class="col-md-12 col-sm-12 no-padding-right-left">
            <div id="accordion">
              <div class="card margin-top-0"
                   *ngIf="!IsSingleRate">
                <div class="card-header">
                  <a class="card-link"
                     data-bs-toggle="collapse"
                     data-bs-target="#collapseOne">
                    {{'component_rate' | translate:param}}
                  </a>
                </div>
                <div id="collapseOne"
                     class="collapse"
                     #componentRateCollapse
                     data-bs-parent="#accordion">
                  <div class="card-body padding-LR-10">
                    <div class="row margin-top-0">
                      <div class="col-md-12 no-padding-right-left margin-top-0">
                        <div class="row">
                          <div class="w-100pc"
                               style="
                              overflow-x: hidden;
                              overflow-y: auto;
                              position: relative;
                            ">
                            <div *ngFor="
                                let item of TaxRateCompoentList;
                                let i = index;
                                let last = last
                              "
                                 class="row margin-top-35">
                              <div class="col-md-5 padding-left-0">
                                <div class="input-group">
                                  <input type="text"
                                         class="form-control has-value"
                                         placeholder="{{ 'eg_cgst' | translate: param }}"
                                         (input)="OnTaxComponentChange()"
                                         [(ngModel)]="item.taxCode" />
                                  <label for="orgName">{{'component_name' | translate:param}}<span>*</span>
                                  </label>
                                  <div *ngIf="
                                      (item.taxCode == '' ||
                                        item.taxCode.trim() == '') &&
                                      Submitted
                                    "
                                       class="alert-danger">
                                    <div *ngIf="
                                        (item.taxCode == '' ||
                                          item.taxCode.trim() == '') &&
                                        Submitted
                                      ">
                                      <b>{{'required_validation' | translate:param}}</b>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-2">
                                <div class="input-group">
                                  <input type="text"
                                         class="form-control has-value"
                                         placeholder="e.g. 20%"
                                         [(ngModel)]="item.taxRate"
                                         (input)="OnTaxComponentChange()"
                                         DecimalOnly
                                         (keypress)="omit_special_char($event)"
                                         maxlength="6" />
                                  <label for="lname">{{'label_rate' | translate:param}}<span>*</span> </label>
                                  <div *ngIf="item.taxRate === '' && Submitted"
                                       class="alert-danger">
                                    <div *ngIf="item.taxRate === '' && Submitted">
                                      <b>{{'required_validation' | translate:param}}</b>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="col-md-4 padding-right-0">
                                <div class="input-group">
                                  <input style="width: 85%;"
                                         type="text"
                                         class="form-control has-value"
                                         (input)="OnTaxComponentChange()"
                                         placeholder="{{ 'acc_code_eg' | translate: param }}"
                                         [(ngModel)]="item.taxAccountingCode" />
                                  <label for="lname">{{'accounting_code' | translate:param}}</label>
                                </div>                                
                              </div>                             
                            </div>
                          </div>
                        </div>
                        <div class="row padding-bottom-20">
                          <div class="col-md-5 padding-left-0">
                            <span class="taxRateSetup-totalTax">{{'total_tax_rate' | translate:param}}</span>
                          </div>
                          <div class="col-md-2">
                            <span class="taxRateSetup-totalTax">{{ TotalTaxRate }}%</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card"
                   *ngIf="!IsFutureRate && this.ShowFutureRate">
                <div class="card-header">
                  <a class="card-link color-orange"
                     data-bs-toggle="collapse"
                     data-bs-target="#collapseOne">
                    {{'future_rate_date_slab' | translate:param}}
                  </a>
                </div>
                <div id="collapseOne"
                     class="collapse"
                     data-bs-parent="#accordion">
                  <div class="">
                    <div class="table-responsive overFlow-y-Scroll-hide">
                      <table class="table table-striped tableBodyScroll">
                        <thead>
                          <tr style="position: relative;">
                            <th>{{'tax_code' | translate:param}}<span class=""> </span></th>

                            <th>Tax Rate<span class=""> </span></th>
                            <th style="width: 25%;">
                              {{'tax_accounting_code' | translate:param}}<span class=""> </span>
                            </th>
                            <th>{{'uk_mileage_effective_from' | translate:param}}<span class=""> </span></th>
                            <th>{{'label_status' | translate:param}}<span class=""> </span></th>
                            <th style="width: 20%;"><span class=""> </span></th>
                          </tr>
                        </thead>
                        <tbody id="expTableValues">
                          <tr *ngFor="let item of FutureTaxRateMasterList">
                            <td>
                              {{ item.taxCode }}
                            </td>
                            <td>{{ item.taxRate }}%</td>
                            <td style="width: 25%;">
                              {{ item.taxAccountingCode }}
                            </td>
                            <td>
                              {{ item.effectiveFrom | date: "dd-MMM-yyyy" }}
                            </td>
                            <td class="color-red">{{'future_rate' | translate:param}}</td>
                            <td [ngClass]="{
                                'row-highlight': item.isRowHighlighted == true
                              }"
                                class="text-right"
                                style="width: 20%;">
                              <a (click)="EditExistingTaxRate(item)"
                                 class="margin-right-5"><i class="fas fa-edit color-green"
                                   data-toggle="tooltip"
                                   ngbTooltip="{{ 'label_edit' | translate }}"
                                   placement="left"
                                   aria-hidden="true"></i></a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card"
                   *ngIf="ShowExpiredRate && !IsFutureRate">
                <div class="card-header">
                  <a class="collapsed card-link color-red"
                     data-bs-toggle="collapse"
                     data-bs-target="#collapseTwo">
                    {{'expired_rate_date_slab' | translate:param}}
                  </a>
                </div>
                <div id="collapseTwo"
                     class="collapse"
                     data-bs-parent="#accordion">
                  <div class="">
                    <div class="table-responsive overFlow-y-Scroll-hide">
                      <table class="table table-striped tableBodyScroll">
                        <thead>
                          <tr style="position: relative;">
                            <th>{{'tax_code' | translate:param}}<span class=""> </span></th>

                            <th>{{'tax_rate' | translate:param}}<span class=""> </span></th>
                            <th style="width: 25%;">
                              {{'tax_accounting_code' | translate:param}}<span class=""> </span>
                            </th>
                            <th>{{'effective_to' | translate:param}}<span class=""> </span></th>
                            <th>{{'label_status' | translate:param}}<span class=""> </span></th>
                          </tr>
                        </thead>
                        <tbody id="expTableValues">
                          <tr *ngFor="let item of ExpiredTaxRateMasterList">
                            <td>
                              {{ item.taxCode }}
                            </td>
                            <td>{{ item.taxRate }}%</td>
                            <td style="width: 25%;">
                              {{ item.taxAccountingCode }}
                            </td>
                            <td>
                              {{ item.effectiveFrom | date: "dd-MMM-yyyy" }}
                            </td>
                            <td class="color-red">{{'expired' | translate:param}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<app-alert-panel [data]="alertPanelModel"
                 (callbackEvent)="alertPanelReceiver($event)"></app-alert-panel>
<app-alert-panel [data]="alertPanelModelForTaxChange"
                 (callbackEvent)="alertPanelReceiverForTaxChange($event)"></app-alert-panel>
